import { render } from "./ClientsPage.vue?vue&type=template&id=45703d82&scoped=true&ts=true"
import script from "./ClientsPage.vue?vue&type=script&lang=ts"
export * from "./ClientsPage.vue?vue&type=script&lang=ts"

import "./ClientsPage.vue?vue&type=style&index=0&id=45703d82&scoped=true&lang=css"
import "./ClientsPage.vue?vue&type=style&index=1&id=45703d82&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45703d82"]])

export default __exports__